import {
  request,
  success,
  failure,
  INCOME_REQUEST,
  PROJECT_REQUEST,
} from "./utilities";
import {
  getAllIncomeTypes,
  addNewIncomeType,
  deleteIncomeType,
  addIncome,
  getAllIncome,
  getProjects,
  deleteIncome,
  getFilteredIncome,
} from "../api";

export function getIncomeTypes() {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.GET_INCOME_TYPE_REQUEST));
    getAllIncomeTypes().then(
      (res) => {
        if (res.data.message === "Success") {
          dispatch(
            success(INCOME_REQUEST.GET_INCOME_TYPE_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(INCOME_REQUEST.GET_INCOME_TYPE_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.GET_INCOME_TYPE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getProjectList() {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_PROJECT_REQUEST));
    getProjects().then(
      (response) => {
        if (response.data.message === "Success") {
          dispatch(
            success(PROJECT_REQUEST.GET_PROJECT_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(PROJECT_REQUEST.GET_PROJECT_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addIncomeType(incomeTypeData, close) {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.ADD_INCOME_TYPE_REQUEST));
    addNewIncomeType(incomeTypeData).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(INCOME_REQUEST.ADD_INCOME_TYPE_SUCCESS, response.data.data)
          );
          if (close) {
            close();
          }
        } else {
          dispatch(
            failure(
              INCOME_REQUEST.ADD_INCOME_TYPE_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.ADD_INCOME_TYPE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function removeIncomeType(incomeTypeId) {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.DELETE_INCOME_TYPE_REQUEST));
    deleteIncomeType(incomeTypeId).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(INCOME_REQUEST.DELETE_INCOME_TYPE_SUCCESS, incomeTypeId)
          );
        } else {
          alert(response.data.message);
          dispatch(
            failure(
              INCOME_REQUEST.DELETE_INCOME_TYPE_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.DELETE_INCOME_TYPE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function editIncomeType(incomeTypeData) {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.EDIT_INCOME_TYPE_REQUEST));
    addNewIncomeType(incomeTypeData).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(INCOME_REQUEST.EDIT_INCOME_TYPE_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(
              INCOME_REQUEST.EDIT_INCOME_TYPE_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.EDIT_INCOME_TYPE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function addNewIncome(incomeData, closePopup) {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.ADD_INCOME_REQUEST));
    addIncome(incomeData).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(INCOME_REQUEST.ADD_INCOME_SUCCESS, response.data.data)
          );
          if (closePopup) {
            closePopup();
          }
          dispatch(getIncomeList());
        } else {
          dispatch(
            failure(INCOME_REQUEST.ADD_INCOME_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.ADD_INCOME_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getIncomeList() {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.GET_INCOME_REQUEST));
    getAllIncome().then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(INCOME_REQUEST.GET_INCOME_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(INCOME_REQUEST.GET_INCOME_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.GET_INCOME_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function removeIncome(incomeId) {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.DELETE_INCOME_REQUEST));
    deleteIncome(incomeId).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(success(INCOME_REQUEST.DELETE_INCOME_SUCCESS, incomeId));
        } else {
          alert(response.data.message);
          dispatch(
            failure(INCOME_REQUEST.DELETE_INCOME_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.DELETE_INCOME_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getFilteredIncomeList(incomeData) {
  return (dispatch) => {
    dispatch(request(INCOME_REQUEST.GET_INCOME_REQUEST));
    getFilteredIncome(incomeData).then(
      (response) => {
        if (response.data.message === "Success") {
          dispatch(
            success(INCOME_REQUEST.GET_INCOME_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(INCOME_REQUEST.GET_INCOME_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            INCOME_REQUEST.GET_INCOME_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
